/* istanbul ignore file */

const error = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Error Icon</title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 0C5.3726 0 0 5.3726 0 12C0 18.6274 5.3726 24 12 24C18.6274 24 24 18.6274 24 12C24 5.3726 18.6274 0 12 0ZM5.93934 8.06066L9.87868 12L5.93934 15.9393L8.06066 18.0607L12 14.1213L15.9393 18.0607L18.0607 15.9393L14.1213 12L18.0607 8.06066L15.9393 5.93934L12 9.87868L8.06066 5.93934L5.93934 8.06066Z"
      fill="#CD1426"
    />
  </svg>
);

export default error;
